<template>
  <b-modal size="lg" hide-footer id="modal-typologies" title="Typologies">
    <b-row class="mb-2">
      <b-col sm="6" class="w-100">
        <b-list-group v-for="typology in typologies" :key="typology.id">
          <b-list-group-item>
            <b-form-input
              :value="typology.name"
              @update="submitUpdate($event, typology.id)"
              debounce="1000"
            ></b-form-input>
          </b-list-group-item>
        </b-list-group>
        <!-- <b-form-group label="Catégories" label-for="sort-by-select">
            <b-form-select
              v-model="typologies"
              multiple
              :options="typologies"
              :select-size="typologies.length"
            ></b-form-select>
          </b-form-group> -->
      </b-col>

      <b-col sm="6">
        <b-card bg-variant="light">
          <b-form @submit.prevent="onSubmit">
            <b-form-group
              label="Nom typology"
              label-for="nested-diagnostic"
              label-cols-sm="3"
              label-align-sm="right"
            >
              <b-form-input
                v-model="form.name"
                @update="updateInput"
                required
              ></b-form-input>
            </b-form-group>
            <b-button
              :disabled="disabled"
              block
              class="mt-3 mb-3"
              type="submit"
              variant="primary"
            >
              Ajouter
              <b-spinner small class="ml-3" v-if="isLoading"></b-spinner>
            </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
// require("json-circular-stringify");

export default {
  name: "ModalTypologiesComponent",
  data() {
    return {
      form: {
        name: "",
      },
      typologies: [],
      isLoading: false,
      edit: false,
      disabled: false,
    };
  },
  components: {},
  mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId === "modal-typologies") {
        this.getTypologies();
      }
    });
    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      if (modalId === "modal-typologies") {
        this.typologies = [];
      }
    });
  },
  methods: {
    getTypologies() {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/typology/getAllTypologies", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then((res) => res.json())
        .then((rep) => {
          // console.log(rep);

          this.typologies = rep
            .map((item) => {
              item.value = item;
              item.text = item.name;
              return { ...item };
            })
            .sort((a, b) => a.id - b.id);
        });
    },
    onSubmit() {
      this.isLoading = true;

      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/typology/saveTypology", {
        method: "POST",
        body: JSON.stringify(this.form),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then((res) => res.json())
        .then((rep) => {
          this.isLoading = false;
          console.log(rep);
          this.success = true;
          this.getTypologies();
          this.form.name = "";
          if (rep.status === 200) {
            // this.form = {
            //   usages: [],
            //   technology: {},
            //   partsAndSpecificities: [
            //     { part: { name: "" }, specificities: [{ name: "" }] },
            //   ],
            //   specificities: [{ name: "", part: {} }],
            //   name: "",
            // };
            this.variant = "success";
            if (this.edit) {
              this.message = "Système modifié avec succès";
            } else {
              this.message = "Système ajouté avec succès";
            }
          } else {
            this.variant = "danger";

            this.message = "Erreur lors  de l'enregistrement";
          }
          setTimeout(() => {
            this.success = false;
          }, 6000);
        })
        .catch((error) => {
          this.errorMessage = error;
          console.error("There was an error!", error);
          this.isLoading = false;
        });
    },
    submitUpdate(name, id) {
      console.log(name, id);
      this.isLoading = true;

      fetch(
        process.env.VUE_APP_API_BASE_URL + "/api/v1/typology/updateTypology",
        {
          method: "POST",
          body: JSON.stringify({ name, id }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((res) => res.json())
        .then((rep) => {
          this.isLoading = false;
          console.log(rep);
          this.success = true;
          this.getTypologies();
        });
    },
    updateInput() {
      console.log(this.typologies);
      this.disabled = this.typologies.some((item) =>
        item.name.includes(this.form.name)
      );
    },
  },
};
</script>
<style></style>
